<cm-table data-name="table">
  <cm-table-head>
    <cm-table-row>
      @if (isCheckboxes) {
        <cm-table-header data-action-center>
          <div class="form-group">
            <div class="form-row example">
              <div class="form-check">
                <label>
                  <input type="checkbox"
                    [class.pseudo-state-indeterminate]="areSomeSelected() ? true : null"
                    [checked]="isAllCheckboxChecked()"
                    (click)="checkboxesDirective.onHeadCheckboxChange($event)">
                  <span class="label"></span>
                </label>
              </div>
            </div>
          </div>
        </cm-table-header>
      }
      <ng-container *ngTemplateOutlet="headers || defaultHeader; context: { $implicit: data }"></ng-container>
    </cm-table-row>
  </cm-table-head>

  <cm-table-body>
    @if (data && !isLoading) {
      @for (row of data; track row) {
        <cm-table-row
          [attr.data-selected]="isRowSelected(row)"
          (click)="onRowClick($event, row)">
          @if (isCheckboxes) {
            <cm-table-data data-action-center>
              <div class="form-group">
                <div class="form-row example">
                  <div class="form-check">
                    <label>
                      <input type="checkbox"
                        [checked]="isRowSelected(row)"
                        (change)="checkboxesDirective.onRowCheckboxChange($event, row)">
                      <span class="label"></span>
                    </label>
                  </div>
                </div>
              </div>
            </cm-table-data>
          }
          <ng-container *ngTemplateOutlet="rows || defaultRow; context: { $implicit: row }"></ng-container>
        </cm-table-row>
      }
    }

    @if (isLoading) {
      @for (i of loadingRowArray; track i) {
        <cm-table-row>
          @if (isCheckboxes) {
            <cm-table-data data-is-loading></cm-table-data>
          }
          <ng-container *ngTemplateOutlet="loadingRows || defaultLoadingRows"></ng-container>
        </cm-table-row>
      }
    }
  </cm-table-body>
</cm-table>

<ng-template #defaultHeader let-data>
  @for (header of data[0] | keyvalue:originalOrder; track header) {
    <cm-table-header>{{ header.key }}</cm-table-header>
  }
</ng-template>

<ng-template #defaultRow let-row>
  @for (cell of row | keyvalue:originalOrder; track cell) {
    <cm-table-data>{{ cell.value }}</cm-table-data>
  }
</ng-template>

<ng-template #defaultLoadingRows>
  <cm-table-data data-is-loading></cm-table-data>
  <cm-table-data data-is-loading></cm-table-data>
  <cm-table-data data-is-loading></cm-table-data>
</ng-template>
